export default __webpack_public_path__ + "static/image/avatar.7d40d5e0.jpeg";